import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Settings } from "lucide-react";
import { BspiHeader, BspiHero, BspiApproach, BspiSituations, BspiServices, BspiWhatWeBuy, BspiFounder, BspiDoubts, BspiInsightsStrip, BspiCloseContact, BspiFooter } from "./components/bspi/HomeSections";
import { ComplaintsProcedurePage } from "./components/ComplaintsProcedurePage";
import { PrivacyPolicyPage } from "./components/PrivacyPolicyPage";
import { TermsOfServicePage } from "./components/TermsOfServicePage";
import { AdminPanel } from "./components/AdminPanel";
import AdminCRMPage from "./components/AdminCRMPage";
import BespokeSourcingPage from "./components/BespokeSourcingPage";
import InvestorBriefPage from "./components/InvestorBriefPage";
import SignBriefPage from "./components/SignBriefPage";
import Analytics from "./components/Analytics";
import DealPage from "./components/DealPage";
import DealsListPage from "./components/DealsListPage";
import InsightPage from "./components/insights/InsightPage";
import InsightsIndex from "./components/insights/InsightsIndex";
import NotFoundPage from "./components/NotFoundPage";

// Check if we're in preview/development environment
const isPreviewEnvironment = () => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  return backendUrl.includes('preview.emergentagent.com') || 
         backendUrl.includes('localhost') ||
         window.location.hostname === 'localhost';
};

const HiddenAdminAccess = ({ onClick }) => {
  // Only show admin button in preview/development environment
  if (!isPreviewEnvironment()) {
    return null;
  }

  return (
    <button
      onClick={onClick}
      data-testid="hidden-admin-trigger"
      className="fixed bottom-6 right-6 z-50 p-2.5 rounded-full 
                 opacity-20 hover:opacity-100 focus:opacity-100
                 transition-all duration-300 ease-in-out
                 bg-[#0a1a14]/80 hover:bg-[#0a1a14] 
                 border border-white/5 hover:border-[#D4AF37]/30
                 group cursor-pointer shadow-lg"
      aria-label="Admin Access"
    >
      <Settings 
        className="w-4 h-4 text-white/30 group-hover:text-[#D4AF37] 
                   transition-all duration-300 group-hover:rotate-90" 
      />
    </button>
  );
};

const HomePage = () => {
  const [showAdmin, setShowAdmin] = useState(false);

  return (
    <div className="bspi">
      <BspiHeader />
      <main>
        <BspiHero />
        <BspiApproach />
        <BspiSituations />
        <BspiServices />
        <BspiWhatWeBuy />
        <BspiFounder />
        <BspiDoubts />
        <BspiInsightsStrip />
        <BspiCloseContact />
      </main>
      <BspiFooter />
      <HiddenAdminAccess onClick={() => setShowAdmin(true)} />
      <AdminPanel
        isOpen={showAdmin}
        onClose={() => setShowAdmin(false)}
      />
    </div>
  );
};

const AdminPage = () => {
  return (
    <div className="min-h-screen bg-[#0a1a14] text-white">
      <AdminPanel
        isOpen={true}
        onClose={() => window.location.href = '/'}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Analytics />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/crm" element={<AdminCRMPage />} />
          <Route path="/bespoke-sourcing" element={<BespokeSourcingPage />} />
          <Route path="/my-brief" element={<InvestorBriefPage />} />
          <Route path="/sign-brief" element={<SignBriefPage />} />
          <Route path="/deals" element={<DealsListPage />} />
          <Route path="/deals/:slug" element={<DealPage />} />
          <Route path="/insights" element={<InsightsIndex />} />
          <Route path="/insights/:slug" element={<InsightPage />} />
          <Route path="/complaints" element={<ComplaintsProcedurePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
